import { gql } from 'apollo-boost'

import { TASK_VIEW_FIELDS } from '../fragments/task-view-fields'

const REOPEN_BRAND_GATEWAY_TASK = gql`
  ${TASK_VIEW_FIELDS}
  mutation reopenBrandGatewayTask($id: ID!) {
    reopenBrandGatewayTask(id: $id) {
      id
      modifiedDate
      reopenedDate
      assignedTo {
        id
        name
      }
      currentViewType
      views {
        ...TaskViewFields
      }
    }
  }
`

export default REOPEN_BRAND_GATEWAY_TASK
